<template>
  <div class="box">
    <div style="font-size: 14px; padding: 10px" v-if="time">
      您于{{ time }}开通联盟商家。
    </div>
    <iframe class="iframe-box" :src="filePath"></iframe>
  </div>
</template>

<script>
import { isApplyLeague } from "api/user";
export default {
  name: "leagueAgreement",

  data() {
    return {
      time: "",
      filePath: "./static/leagueAgreement.html",
    };
  },
  created() {
    this.isApplyLeague();
  },

  mounted() {},

  methods: {
    //查询是否申请过联盟商家
    isApplyLeague() {
      isApplyLeague({}).then((res) => {
        if (res.data) {
          if (res.resCode == 1) {
            if (res.data.status == 2) {
              this.time = res.data.createdAt;
            } else {
              return;
            }
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less" rel="stylesheet/less">
.box {
  width: 1190px;
  margin: auto;
  background: #fff;

  .iframe-box {
    margin-top: 50px;
    width: 100%;
    height: 1000px;
    overflow: auto;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// leagueAgreement.vue?6d83d096